import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './landing.scss';

import checkIcon from 'assets/images/landing/check_icon.svg';
import chetana from 'assets/images/landing/chetana.jpeg';
import doodle from 'assets/images/landing/doodle.svg';
import doodleString from 'assets/images/landing/doodle_string.svg';
import emily from 'assets/images/landing/emily.jpeg';
import goDaddyLogo from 'assets/images/landing/goDaddyLogo.png';
import googleLogo from 'assets/images/landing/google_logo.png';
import hero from 'assets/images/landing/hero.png';
import kanban from 'assets/images/landing/kanban.png';
import { ReactComponent as NavbarLogo } from 'assets/images/landing/logo.svg';
import netflixLogo from 'assets/images/landing/netflix.png';
import oktaLogo from 'assets/images/landing/oktaLogo.png';
import plugin from 'assets/images/landing/plugin.png';
import search from 'assets/images/landing/search.png';
import sheba from 'assets/images/landing/sheba.jpeg';
import spiral from 'assets/images/landing/spiral.svg';
import testimonials from 'assets/images/landing/testimonials.png';
import uberLogo from 'assets/images/landing/uberLogo.png';

import Login from 'Components/Login/Login';

import { ROUTES } from 'routes/route.constants';

import { getCurrentYear } from 'utlis/date';

export const LandingPageUI = ({ installButton, fromPluginAuth }) => {
  return (
    <div className="landing-wrapper">
      <div
        data-w-id="18f5e840-a1f4-abea-0a7d-01cd0522445d"
        data-animation="default"
        data-collapse="medium"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        className="navbar-logo-left w-nav"
      >
        <div className="navbarcontainer w-container">
          <div className="navbar-content">
            <div className="navbar-brand">
              <div className="logo">
                <NavbarLogo />
              </div>
            </div>
            <nav role="navigation" className="navbar-menu w-nav-menu">
              <a href="#features" className="navbar-link w-nav-link">
                <div className="text">
                  Features
                </div>
              </a>
              <a href="#pricing" className="navbar-link w-nav-link">
                <div className="text">
                  Pricing
                </div>
              </a>
            </nav>
          </div>
          <div
            className="menu-button w-nav-button"
            onClick={handleShowNavMenu}
            style={{ WebkitUserSelect: 'text' }}
            aria-label="menu"
            role="button"
            tabIndex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="true"
          >
            <div className="w-icon-nav-menu" />
          </div>
        </div>
        <div
          className="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
        >
          <nav
            role="navigation"
            className="navbar-menu w-nav-menu"
            onClick={handleShowNavMenu}
            data-nav-menu-open=""
          >
            <a
              href="#"
              className="navbar-link w-nav-link w--nav-link-open"
              style={{ maxWidth: '1200px' }}
            >
              <div className="text">
                Features
              </div>
            </a>
            <a
              href="#pricing"
              className="navbar-link w-nav-link w--nav-link-open"
              style={{ maxWidth: '1200px' }}
            >
              <div className="text">
                Pricing
              </div>
            </a>
          </nav>
        </div>
      </div>
      <div data-w-id="d8094754-af3a-caf3-44b7-73159b57d910" className="hero-stack">
        <div className="small-container">
          <div className="title-section">
            <div className="content">
              <a className="button-3">
                From the creators of Siri
              </a>
              <div data-w-id="d8094754-af3a-caf3-44b7-73159b57d914" className="h1">
                Your AI design copilot
              </div>
              <div data-w-id="d8094754-af3a-caf3-44b7-73159b57d916" className="h5">
                Boost your team's design velocity - get design reviews,
                extract insights and tasks, and resolve UX issues instantly.
              </div>
            </div>
            <div className="actions">
              {installButton}
            </div>
          </div>
          <img
            src={hero}
            srcSet="https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bde5774554a954672652_Hero%202-p-500.png 500w,
            https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bde5774554a954672652_Hero%202-p-800.png 800w,
            https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bde5774554a954672652_Hero%202-p-1080.png 1080w,
            https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bde5774554a954672652_Hero%202-p-1600.png 1600w,
            https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bde5774554a954672652_Hero%202-p-2000.png 2000w,
            https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bde5774554a954672652_Hero%202-p-2600.png 2600w,
            https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bde5774554a954672652_Hero%202.png 2880w"
            sizes="(max-width: 479px) 90vw,
            (max-width: 767px) 94vw,
            (max-width: 991px) 95vw,
            (max-width: 1439px) 96vw,
            1199.9921875px"
            alt=""
            className="image-61"
          />
        </div>
      </div>
      <div data-w-id="5acd1e33-f2e5-feec-dbde-25cfc05ef646" className="logo-title">
        <div className="title">
          DesignPro helps designers, product managers, and teams design better and faster
        </div>
        <div className="content-10">
          <div className="logos f2wf-columns-3">
            <div className="logo-wrapper">
              <img
                src={googleLogo}
                loading="lazy"
                alt=""
                className="logo"
                width={288}
              />
            </div>
            <div className="logo-wrapper">
              <img
                src={uberLogo}
                loading="lazy"
                width="192"
                alt=""
                className="logo"
              />
            </div>
            <div className="logo-wrapper">
              <img
                src={oktaLogo}
                loading="lazy"
                alt=""
                className="logo"
                width={210}
                sizes="(max-width: 479px) 100px, (max-width: 767px) 11vw, (max-width: 1439px) 9vw, 124.4921875px"
              />
            </div>
            <div className="logo-wrapper">
              <img
                src={netflixLogo}
                loading="lazy"
                alt=""
                className="logo"
                width={230}
              />
            </div>
            <div className="logo-wrapper">
              <img
                src={goDaddyLogo}
                loading="lazy"
                alt=""
                className="logo"
                width={308}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="section-2">
        <div className="container-3 f2wf-columns-3">
          <div className="column-12">
            <div className="content-12">
              <h1 className="h2">
                Get quality design reviews in minutes
              </h1>
              <p className="h6">
                DesignPro will analyze your designs, providing valuable feedback and actionable recommendations.
                This allows you to quickly identify and correct issues, ensuring your designs align with best practices.
              </p>
              <a
                href="https://www.figma.com/community/plugin/1339202278007297015"
                className="button-4 w-button"
              >
                Install the Figma Plugin
              </a>
            </div>
          </div>
          <div className="column-13">
            <div className="image-wrapper-10">
              <img
                src={search}
                loading="lazy"
                sizes="(max-width: 479px) 80vw,
                (max-width: 767px) 87vw,
                (max-width: 991px) 90vw,
                (max-width: 1439px) 51vw,
                720px"
                srcSet="https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bc80ebbe7bffdc312726_Design%20Reviewer-p-500.png 500w,
                https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bc80ebbe7bffdc312726_Design%20Reviewer-p-800.png 800w,
                https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bc80ebbe7bffdc312726_Design%20Reviewer-p-1080.png 1080w,
                https://assets-global.website-files.com/661c99f39107f68356147fa7/6624bc80ebbe7bffdc312726_Design%20Reviewer.png 1162w"
                alt=""
                className="feature-image"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="section-2">
        <div className="container-3 f2wf-columns-3">
          <div className="column-12">
            <div className="content-12">
              <h1 className="h2">
                Extract insights and tasks in seconds
              </h1>
              <p className="h6">
                DesignPro’s AI will analyze your discussions and documents and generate clear,
                accurate insights and tasks in seconds so that you can provide clarity and alignment to your team.
              </p>
              <a
                href="https://www.figma.com/community/plugin/1288854102538019029/designpro-ai-task-manager"
                className="button-4 w-button"
              >
                Install the Figma Plugin
              </a>
            </div>
          </div>
          <div className="column-13">
            <div className="image-wrapper-10">
              <img
                src={plugin}
                loading="lazy"
                sizes="(max-width: 479px) 90vw,
                (max-width: 767px) 94vw,
                (max-width: 991px) 95vw,
                (max-width: 1439px) 50vw,
                720px"
                srcSet="https://assets-global.website-files.com/6422d2a12ea92e43007916e5/65d2b07086ea9062ba3b7bf0_plugin-p-500.png 500w,
                https://assets-global.website-files.com/6422d2a12ea92e43007916e5/65d2b07086ea9062ba3b7bf0_plugin-p-800.png 800w,
                https://assets-global.website-files.com/6422d2a12ea92e43007916e5/65d2b07086ea9062ba3b7bf0_plugin-p-1080.png 1080w,
                https://assets-global.website-files.com/6422d2a12ea92e43007916e5/65d2b07086ea9062ba3b7bf0_plugin-p-1600.png 1600w,
                https://assets-global.website-files.com/6422d2a12ea92e43007916e5/65d2b07086ea9062ba3b7bf0_plugin-p-2000.png 2000w,
                https://assets-global.website-files.com/6422d2a12ea92e43007916e5/65d2b07086ea9062ba3b7bf0_plugin.png 2420w"
                alt=""
                className="feature-image"
              />
            </div>
          </div>
        </div>
      </div>
      <div id="features" className="section-1">
        <div className="container-3">
          <div className="column-12">
            <div className="content-3">
              <h1 className="h2">
                Resolve UX and usability issues

              </h1>
              <p className="h6">
                Conduct design QA by comparing the implemented designs with the ones in Figma.
                Get reported UX and usability errors, which can then be instantly resolved using AI-generated solutions.
              </p>
            </div>
          </div>
          <div className="column-13">
            <div className="image-wrapper-10">
              <img
                src={kanban}
                loading="lazy"
                sizes="(max-width: 479px) 90vw,
                (max-width: 767px) 94vw,
                (max-width: 991px) 95vw,
                (max-width: 1439px) 55vw, 720px"
                srcSet="https://assets-global.website-files.com/661c99f39107f68356147fa7/6624be69a652ac3847737121_Design%20QA-p-500.png 500w,
                https://assets-global.website-files.com/661c99f39107f68356147fa7/6624be69a652ac3847737121_Design%20QA-p-800.png 800w,
                https://assets-global.website-files.com/661c99f39107f68356147fa7/6624be69a652ac3847737121_Design%20QA-p-1080.png 1080w,
                https://assets-global.website-files.com/661c99f39107f68356147fa7/6624be69a652ac3847737121_Design%20QA.png 1422w"
                alt=""
                className="feature-image"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="logo-title-2">
        <div className="column-6">
          <div className="content">
            <h1 className="h2 align-center">
              Trained on best-practices in design
            </h1>
            <p className="h6 align-center">
              DesignPro's AI is trained on frameworks from Nielson Norman, and IDEO.
              It helps your team apply best practice principles used by the best teams in the world.
              <br />
            </p>
          </div>
          <div className="image-wrapper-6">
            <img
              src={testimonials}
              loading="lazy"
              sizes="(max-width: 479px) 90vw, (max-width: 767px) 94vw, (max-width: 1439px) 95vw, 1199.9765625px"
              srcSet="https://uploads-ssl.webflow.com/6422d2a12ea92e43007916e5/65237494e7c8619fb77ce9ea_best%20practices-p-500.png 500w,
            https://uploads-ssl.webflow.com/6422d2a12ea92e43007916e5/65237494e7c8619fb77ce9ea_best%20practices-p-800.png 800w,
            https://uploads-ssl.webflow.com/6422d2a12ea92e43007916e5/65237494e7c8619fb77ce9ea_best%20practices-p-1080.png 1080w,
            https://uploads-ssl.webflow.com/6422d2a12ea92e43007916e5/65237494e7c8619fb77ce9ea_best%20practices.png 1592w"
              alt=""
              className="image-62"
            />
          </div>
        </div>
      </div>
      <div data-w-id="53824dd9-af05-1378-ec27-b629afd5e948" className="testimonial-column-light">
        <div className="testimonial-header">
          <img
            src={spiral}
            loading="lazy"
            width="89"
            alt=""
            className="spiral-2"
          />
          <div className="h3 align-center">
            Designers and product teams love using DesignPro
          </div>
        </div>
        <div className="columns f2wf-columns-2">
          <div className="column">
            <div className="testimonial">
              <div className="quote">
                <div className="text-5">
                  “I wish I had DesignPro for my team at Uber.
                  The magic part is having all the feedback laid out all labeled and tagged beautifully in an inbox.”
                </div>
                <div className="author">
                  <div className="avatar">
                    <img
                      src={emily}
                      loading="lazy"
                      alt=""
                      className="avatar-image"
                    />
                  </div>
                  <div className="info">
                    <div className="text-6">
                      Emily H.
                    </div>
                    <div className="text-7">
                      ex-Staff Designer, Uber
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="column">
            <div className="testimonial">
              <div className="quote-2">
                <div className="text-5">
                  “I’ve had sleepless nights trying to make my design critiques more effective.
                  When I tried DesignPro I think of all those moments in my career
                  where I wish DesignPro could have been there.”
                </div>
                <div className="author">
                  <div className="avatar">
                    <img
                      src={chetana}
                      loading="lazy"
                      width="200"
                      alt=""
                      className="avatar-image"
                    />
                  </div>
                  <div className="info">
                    <div className="text-6">
                      Chetana
                    </div>
                    <div className="text-7">
                      Design Director, Netflix
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="column">
            <div className="testimonial">
              <div className="quote">
                <div className="text-5">
                  “For many designers, organizing and prioritizing feedback is the hardest thing. If
                  DesignPro can solve this problem with AI, it would blow my mind.”
                </div>
                <div className="author">
                  <div className="avatar">
                    <img
                      src={sheba}
                      loading="lazy"
                      alt=""
                      className="avatar-image"
                    />
                  </div>
                  <div className="info">
                    <div className="text-6">
                      Sheba
                    </div>
                    <div className="text-7">
                      Design Manager, LinkedIn
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="image-wrapper-8" />
      </div>
      <div id="pricing" className="pricing-comparison">
        <div className="column-6">
          <div className="content">
            <h1 className="h2 align-center">
              Turn your products into gems
            </h1>
            <p className="h6 align-center">
              DesignPro is a better way to design products. Enable faster iterations, saving time and costs.
            </p>
          </div>
        </div>
        <div className="columns-2 f2wf-columns-2">
          <img
            src={doodleString}
            loading="lazy"
            alt=""
            className="doodle-13"
          />
          <img
            src={doodle}
            loading="lazy"
            alt=""
            className="doodle-15"
          />
          <img
            src={doodle}
            loading="lazy"
            alt=""
            className="doodle-14"
          />
          <div className="pricing-plan">
            <div className="intro">
              <div className="name">
                <div className="text-8">
                  Free (Beta)
                </div>
              </div>
              <div className="pricing">
                <div className="_599-mo">
                  $0
                </div>
                <div>
                  per user / month
                </div>
              </div>
            </div>
            <div className="separator" />
            <div className="features">
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  10 reviews

                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  AI insights & task generator
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  AI design reviewer
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  Sync with Figma, Figjam
                  <br />
                  Jira, Slack, Google Docs
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  30 day search history
                </div>
              </div>
            </div>
            <Login
              className="width-full flex text-center"
              loginButtonClassName="button primary"
              fromPluginAuth={fromPluginAuth}
            >
              <div className="button-label-2">
                Sign-in to try for free
              </div>
            </Login>
          </div>
          <div className="pricing-plan">
            <div className="intro">
              <div className="name">
                <div className="text-8">
                  Starter (Coming Soon)
                </div>
              </div>
              <div className="pricing">
                <div className="_599-mo">
                  $8
                </div>
                <div>
                  per user / month
                </div>
              </div>
            </div>
            <div className="separator" />
            <div className="features">
              <div className="pricing-feature">
                <div className="feature-item">
                  <strong>
                    Everything in Free, and
                  </strong>
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  Unlimited reviews
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  Export to Jira, Notion
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  Coaching on design skills
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  60 day search history
                </div>
              </div>
              <div className="pricing-feature">
                <div className="icon">
                  <img
                    src={checkIcon}
                    loading="lazy"
                    alt=""
                    className="icon-wrapper"
                  />
                </div>
                <div className="feature-item">
                  Invite collaborators
                </div>
              </div>
            </div>
            <Login
              className="width-full flex text-center"
              loginButtonClassName="button primary"
              fromPluginAuth={fromPluginAuth}
            >
              <div className="button-label-2">
                Sign-in to try for free
              </div>
            </Login>
          </div>
        </div>
        <div className="image-wrapper-9" />
      </div>
      <div className="footer">
        <div className="columns-3 f2wf-columns-3">
          <div className="column-10">
            <div className="logo-wrapper-2">
              <div className="logo-3">
                <NavbarLogo />
              </div>
            </div>
          </div>
          <div className="small-columns f2wf-small-columns">
            <div className="column-11">
              <div className="content-9">
                <div className="footer-links">
                  <Link className="footer-link" to={ROUTES.TERMS_AND_CONDITIONS}>
                    Terms and Conditions
                  </Link>
                  <Link to={ROUTES.PRIVACY_POLICY} className="footer-link">
                    Privacy Policy
                  </Link>
                  <div className="text-10">
                    ©
                    {' '}
                    {
                      getCurrentYear()
                    }
                    {' '}
                    Creative Labs, Inc
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  function handleShowNavMenu() {
    document.querySelector('.w-nav-button').classList.toggle('w--open');
    document.querySelector('.w-nav-overlay').classList.toggle('w-nav-overlay-show');
  }
};

LandingPageUI.propTypes = {
  installButton: PropTypes.node,
  fromPluginAuth: PropTypes.bool,
};
